<template>
  <CelusAlert type="warning">
    <slot />
  </CelusAlert>
</template>

<script setup lang="ts">
import CelusAlert from "@/components/util/CelusAlert.vue";

defineOptions({
  name: "CelusWarningAlert",
});
</script>
